import { createSurveyTheme } from './theme'

export const coorumColors = {
  mainColor: '#FABE0A',
  mainTextColor: '#1B1C1B',
  secondaryColor: '#E7E8E7',
  generalBgColor: '#FFFFFF',
}

export const coorumTheme = createSurveyTheme(coorumColors)
